import * as Sentry from '@sentry/react';
import { useCallback } from 'react';

import { useToast } from '@/components/ui/toast-context';
import { ApiError } from '@/lib/api-client';
import { toFriendlyError } from '@/lib/utils/error-handler';

export function useErrorHandler() {
  const { addToast } = useToast();

  const handleError = useCallback(
    (error: unknown, options?: { onRetry?: () => void }) => {
      const friendly = toFriendlyError(error);
      addToast({
        variant: 'error',
        ...friendly,
        onRetry: options?.onRetry,
      });

      // Report to Sentry (skip auth errors — those are expected redirects)
      if (error instanceof ApiError && (error.status === 401 || error.status === 403)) return;
      if (error instanceof Error) {
        Sentry.captureException(error);
      }
    },
    [addToast],
  );

  return { handleError };
}
